<template>
  <div>

    <table class="table table-warning table-decision">
      <thead>
      <tr>
        <th scope="col">Decision</th>
        <th scope="col">Suggested score</th>
      </tr>
      </thead>
      <tr v-if="local.considerations.length>0 && local.decisions.length>0" v-for="(decision, decisionIndex) in decisionTable">
        <td>{{decision.name}}</td>
        <td>{{decision.label}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';

export default {
  props: ['scenarioTesting', 'maxScore', 'testScore'],
  name: "CreateDecisionTable",

  data() {
    return {
      local: {
        considerations: [],
        decisions: [],
      },
    };
  },


  methods: {
    ...mapMutations('data', [
      'commitConsiderations',
      'commitDecisionTable',
      'commitScoreCard',
    ]),
  },

  mounted() {
    this.local.considerations = [...this.dataConsiderations];
    this.local.decisions = [...this.dataDecisions];
  },

  computed: {
    ...mapState('data', {
      dataConsiderations: state => state.matrix.considerations,
      dataDecisions: state => state.matrix.decisions,
      dataScoreCard: state => state.matrix.scoreCard,
    }),

    ...mapState('config', [
      'scoreRating',
    ]),

    decisionTable: function () {

      //how many decisions?
      //what is the risk rating? create json object for risk rating?
      //decide tolerance values based on number of decisions using given table

      let decisionCount = this.local.decisions.length
      let scoreCard = {}
      if(!(_.isUndefined(this.scoreRating.decisions[decisionCount]))) {

        let tolerance = this.scoreRating.decisions[decisionCount].tolerance
        let riskRating = this.dataScoreCard.riskRating
        let maxScore = this.maxScore

        scoreCard = {
          maxScore: maxScore,
          riskRating: this.riskRating
        }

        let lower_score = Math.round(maxScore*tolerance[riskRating].lower)
        let upper_score = Math.round(maxScore*tolerance[riskRating].upper)
        let lower_intermediate = Math.round(maxScore*tolerance[riskRating].lower_intermediate)
        let upper_intermediate = Math.round(maxScore*tolerance[riskRating].upper_intermediate)

        switch (decisionCount) {
          case 2:
            this.local.decisions[0].lower_score = lower_score
            this.local.decisions[0].label = 'More than ' + lower_score
            this.local.decisions[0].confirmed_lower_score = this.local.decisions[0].confirmed_lower_score ?? lower_score
            this.local.decisions[0].label_confirmed = 'More than '

            this.local.decisions[1].upper_score = upper_score
            this.local.decisions[1].label = 'Less than or equal ' + upper_score
            this.local.decisions[1].confirmed_upper_score = this.local.decisions[1].confirmed_upper_score ?? upper_score
            this.local.decisions[1].label_confirmed = 'Less than or equal '

            break;

          case 3:
            this.local.decisions[0].lower_score = lower_score
            this.local.decisions[0].label = 'More than ' + lower_score
            this.local.decisions[0].confirmed_lower_score = this.local.decisions[0].confirmed_lower_score ?? lower_score
            this.local.decisions[0].label_confirmed = 'More than '

            this.local.decisions[1].lower_score = upper_score
            this.local.decisions[1].upper_score = lower_score
            this.local.decisions[1].label =  upper_score + ' to ' + lower_score

            this.local.decisions[1].confirmed_lower_score = this.local.decisions[1].confirmed_lower_score ?? upper_score
            this.local.decisions[1].confirmed_upper_score = this.local.decisions[1].confirmed_upper_score ?? lower_score

            this.local.decisions[2].upper_score = upper_score
            this.local.decisions[2].label=  'Less than ' + upper_score
            this.local.decisions[2].confirmed_upper_score =  this.local.decisions[2].confirmed_upper_score ?? upper_score
            this.local.decisions[2].label_confirmed =  'Less than '

            break;

          case 4:
            this.local.decisions[0].lower_score = lower_score
            this.local.decisions[0].label = 'More than ' + lower_score
            this.local.decisions[0].confirmed_lower_score = this.local.decisions[0].confirmed_lower_score ?? lower_score
            this.local.decisions[0].label_confirmed = 'More than '

            this.local.decisions[1].lower_score = lower_intermediate
            this.local.decisions[1].upper_score = lower_score
            this.local.decisions[1].label = lower_intermediate + ' to ' + lower_score

            this.local.decisions[1].confirmed_lower_score = this.local.decisions[1].confirmed_lower_score ?? lower_intermediate
            this.local.decisions[1].confirmed_upper_score = this.local.decisions[1].confirmed_upper_score ?? lower_score

            this.local.decisions[2].lower_score = upper_score
            this.local.decisions[2].upper_score = upper_intermediate
            this.local.decisions[2].label = upper_score + ' to ' + upper_intermediate

            this.local.decisions[2].confirmed_lower_score = this.local.decisions[2].confirmed_lower_score ?? upper_score
            this.local.decisions[2].confirmed_upper_score = this.local.decisions[2].confirmed_upper_score ?? upper_intermediate

            this.local.decisions[3].upper_score = upper_score
            this.local.decisions[3].label = 'Less than ' + upper_score
            this.local.decisions[3].confirmed_upper_score = this.local.decisions[3].confirmed_upper_score ?? upper_score
            this.local.decisions[3].label_confirmed = 'Less than '
            break;
        }
      }

      return this.local.decisions //we just return max score
    },
  },
}
</script>

<style scoped>
.table-decision {
  background-color: #fffde9;;
}
</style>